import React,{useReducer} from 'react'
import CartContext from './CartContext';

const defaultCartState = {
  items : [],
  totalamount : 0,

};
const cartReducer = (state,action) => {
  if(action.type === 'ADD'){

    const updatedTotalAmount = state.totalamount + action.item.price * action.item.amount;

    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.item.id
    );

    const existingCartItem = state.items[existingCartItemIndex];
    // let updatedItem;
    let updatedItems;


    if (existingCartItem) {
      const updatedItem = {
        ...existingCartItem,
        amount: existingCartItem.amount + action.item.amount,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    } else {
      updatedItems = state.items.concat(action.item);
    }


    // const updatedItems = state.items.concat(action.item);


    return {
      items: updatedItems,
      totalamount: updatedTotalAmount
    }

  
  }

  if(action.type==='REMOVE'){

  
    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.id
    );

    const existingItem = state.items[existingCartItemIndex]
    const updatedTotalAmount = state.totalamount - existingItem.price;
    let updatedItems;
    if(existingItem.amount===1){
      updatedItems=state.items.filter(item => item.id != action.id)

    }
    else{

      const updatedItem = {...existingItem, amount : existingItem.amount-1};

      updatedItems = [...state.items]

      updatedItems[existingCartItemIndex]= updatedItem

    }

    return{

      items:updatedItems,
      totalamount: updatedTotalAmount

    }




  }

return defaultCartState;
};


export default function CartProvider(props) {

 const [cartState, dispatchCartAction] = useReducer(cartReducer,defaultCartState)


  const addItemToCartHandler = item => {

  dispatchCartAction({type: 'ADD', item:item});

  };


  const removeItemToCartHandler = id => {
    dispatchCartAction({type: 'REMOVE', id:id});
  };


  const cartContext ={
    items : cartState.items,
    totalamount : cartState.totalamount,
    addItem: addItemToCartHandler,
    removeItem: removeItemToCartHandler,



  };
  return (
    <CartContext.Provider value={cartContext}>
      {props.children}

    </CartContext.Provider>

  )
}
